(() => {
  const moneyWithLeadingCurrency = /\b(?:KM|BAM)\s*(-?\d[\d.,\s]*(?:[,.]\d{2}))\s*(?:BAM|KM)?\b/g;
  const moneyWithTrailingCurrency = /\b(-?\d[\d.,\s]*(?:[,.]\d{2}))\s*(?:BAM|KM)\b/g;
  const ignoredTags = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION']);

  const formatNumber = (value) => {
    let number = value.replace(/\s+/g, '');
    const lastComma = number.lastIndexOf(',');
    const lastDot = number.lastIndexOf('.');

    if (lastDot > lastComma) {
      number = number.replace(/,/g, '').replace(/\.(\d{2})$/, ',$1');
    }

    return `${number}KM`;
  };

  const normalizeMoneyText = (value) =>
    value
      .replace(moneyWithLeadingCurrency, (_, amount) => formatNumber(amount))
      .replace(moneyWithTrailingCurrency, (_, amount) => formatNumber(amount));

  const normalizeTextNode = (node) => {
    const nextValue = normalizeMoneyText(node.nodeValue);

    if (nextValue !== node.nodeValue) {
      node.nodeValue = nextValue;
    }
  };

  const walk = (root) => {
    if (!root || ignoredTags.has(root.nodeName)) return;

    if (root.nodeType === Node.TEXT_NODE) {
      normalizeTextNode(root);
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.parentElement && !ignoredTags.has(node.parentElement.nodeName)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      },
    });

    while (walker.nextNode()) {
      normalizeTextNode(walker.currentNode);
    }
  };

  const start = () => {
    walk(document.body);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          normalizeTextNode(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(walk);
      });
    }).observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
